import { render } from "./nq-buildings.vue?vue&type=template&id=cb85696c&scoped=true"
import script from "./nq-buildings.vue?vue&type=script&lang=js"
export * from "./nq-buildings.vue?vue&type=script&lang=js"

import "./nq-buildings.vue?vue&type=style&index=0&id=cb85696c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb85696c"]])

export default __exports__